export default {
  teacherCount: null,
};
